import $ from 'jquery'
import _throttle from 'lodash/throttle'
import * as Ease from './utils/ease'

const $body = $('html,body')
const elements = []
let windowWidth = 1000
let windowHeight = 800
let scrollPosition = 0
let animatingScroll = false
let lastScrollWasJacked = false
let forceScrollPosition = 0
let scrollAimPosition = 0
let originalScrollPosition = 0
let lastScrollDiff = 0
let startJackTimestamp = new Date().getTime()
let finishedJackTimestamp = new Date().getTime()

export function init() {
  // screw scrolljacking on mobile ... well in general
  if ($(window).width() <= 1024) return

  $('[data-scroll-jack]').each((i, elem) => {
    const $elem = $(elem)

    const $prevSection = $elem.prev('section')
    const $nextSection = $elem.next('section')

    const isLast = !$nextSection.length || !$nextSection.is('[data-scroll-jack]')
    const isFirst = !$prevSection.length || !$prevSection.is('[data-scroll-jack]')

    elements.push({
      $elem,
      isLast,
      isFirst,
    })
  })

  // use this instead of jQuery
  if (window.addEventListener) window.addEventListener('DOMMouseScroll', handleScrollEvent, false) // older FF
  window.onwheel = handleScrollEvent // modern standard
  window.onmousewheel = document.onmousewheel = handleScrollEvent // older browsers, IE
  window.ontouchmove = handleScrollEvent // mobile

  // $(document).on('scroll', _throttle(handleScroll, 1000/60));
  $(window).on('resize', _throttle(handleResize, 1000 / 30))

  // run once to position elements
  handleResize()
  handleScroll()
  animate()
}

function handleResize() {
  windowWidth = $(window).width()
  windowHeight = $(window).height()
  if (lastScrollWasJacked) {
    $body.scrollTop(scrollAimPosition)
  }
}

// this has to run on every event
function handleScrollEvent(event) {
  if (event) {
    const timeSinceLastJack = (new Date().getTime() - finishedJackTimestamp) / 1000 // seconds
    if (animatingScroll || (!animatingScroll && timeSinceLastJack < 1 && Math.abs(event.deltaY) < 15)) {
      const e = event || window.event
      if (e.preventDefault) e.preventDefault()
      e.returnValue = false
    }
  }
  handleScroll()
}

// this gets throttled, triggered from handleScrollEvent
const handleScroll = _throttle((event) => {
  const oldScrollPosition = scrollPosition
  scrollPosition = $(document).scrollTop()
  const scrollDiff = scrollPosition - oldScrollPosition
  const acceleration = Math.abs(Math.abs(scrollDiff) - Math.abs(lastScrollDiff))
  const timeSinceLastJack = (new Date().getTime() - finishedJackTimestamp) / 1000 // seconds
  const requiredSpeed = timeSinceLastJack < 3.5 ? 10 : 1

  if (!animatingScroll && acceleration > requiredSpeed) {
    lastScrollWasJacked = false
    for (let element of elements) {
      const elementOffset = element.$elem.offset()
      const scrollOffset = scrollPosition - elementOffset.top

      let extraOffset = 0
      if (scrollDiff > 1 && element.isFirst) extraOffset = -windowHeight / 2
      if (scrollDiff < -1 && element.isLast) extraOffset = windowHeight / 2

      // scroll down
      if (
        scrollDiff > 1 &&
        scrollOffset + extraOffset + windowHeight > 0 &&
        scrollOffset + windowHeight < windowHeight
      ) {
        originalScrollPosition = scrollPosition
        forceScrollPosition = scrollPosition
        scrollAimPosition = elementOffset.top
        animatingScroll = true
        lastScrollWasJacked = true
        startJackTimestamp = new Date().getTime()
        // scroll up
      } else if (scrollDiff < -1 && scrollOffset + extraOffset + windowHeight < windowHeight * 2 && scrollOffset > 0) {
        originalScrollPosition = scrollPosition
        forceScrollPosition = scrollPosition
        scrollAimPosition = elementOffset.top
        animatingScroll = true
        lastScrollWasJacked = true
        startJackTimestamp = new Date().getTime()
      }
    }
  }

  lastScrollDiff = scrollDiff
}, 1000 / 60)

function animate() {
  if (animatingScroll) {
    const elapsed = new Date().getTime() - startJackTimestamp
    const distance = scrollAimPosition - originalScrollPosition
    forceScrollPosition = originalScrollPosition + Ease.easeOutCirc(null, elapsed, 0, distance, 500)
    $body.scrollTop(forceScrollPosition)
    if (Math.abs(forceScrollPosition - scrollAimPosition) < 1) {
      animatingScroll = false
      finishedJackTimestamp = new Date().getTime()
    }
  }
  requestAnimationFrame(animate)
}
